<template>
  <div class="padding-15 border-radius-5 info">
    <base-info />
    <div class="color-bg-fff border-radius-5 padding-10 margin-bottom-20">
      <div class="title-box">会员信息</div>
      <member-info />
    </div>
    <div class="color-bg-fff border-radius-5 padding-10 margin-bottom-20">
      <div class="title-box">订单信息</div>
      <order
        :order="userInfo.orderPage"
        :userInfoOrder="userInfo.userInfoOrderCountVo"
        :userId="userInfo.baseUserInfoVo.userId"
      />
    </div>
    <div class="color-bg-fff border-radius-5 padding-10 margin-bottom-20">
      <div class="title-box">优惠券 {{ userInfo.customUserRecordPageVoRep.total }}</div>
      <coupon
        :coupon="userInfo.customUserRecordPageVoRep"
        :statisticsUserCoupon="userInfo.statisticsUserCoupon"
        :mobilePhone="userInfo.baseUserInfoVo.mobilePhone"
      />
    </div>
    <div class="color-bg-fff border-radius-5 padding-10 margin-bottom-20">
      <div class="title-box">投诉建议 {{ userInfo.suggestionPage.total }}</div>
      <suggestion :suggestion="userInfo.suggestionPage" :userId="userInfo.baseUserInfoVo.userId" />
    </div>
    <div class="color-bg-fff border-radius-5 padding-10 margin-bottom-20">
      <div class="title-box">短信/通知/邮件</div>
      <message
        :message="userInfo.messageRecordPage"
        :mobile="userInfo.baseUserInfoVo.mobilePhone"
      />
    </div>
    <div class="color-bg-fff border-radius-5 padding-10 margin-bottom-20">
      <div class="title-box">乘车人</div>
      <passenger
        :passenger="userInfo.userCommonPassengerPage"
        :userId="userInfo.baseUserInfoVo.userId"
      />
    </div>
    <div class="color-bg-fff border-radius-5 padding-10 margin-bottom-20">
      <div class="title-box">接送机订单</div>
      <pickup-order
        :first-list="userInfo.ferryOrderPageRepVo"
        :userId="userInfo.baseUserInfoVo.userId"
      />
    </div>
  </div>
</template>

<script >
import BaseInfo from './base-info.vue';
import MemberInfo from './member-info.vue';
import order from './order';
import coupon from './coupon';
import suggestion from './suggestion';
import message from './message';
import passenger from './passenger';
import PickupOrder from './pickup-order';
import { inject, watch } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const userInfo = inject('userInfo', {});
  watch(userInfo, val => {
    console.log('object:', val);
  });
  return {
    userInfo
  };
};
__sfc_main.components = Object.assign({
  BaseInfo,
  MemberInfo,
  order,
  coupon,
  suggestion,
  message,
  passenger,
  PickupOrder
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .info {
    background-color: #efefef;
  }
  .title-box {
    margin-left: 20px;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
    position: relative;

    &::before {
      content: ' ';
      background-color: #22c655;
      width: 4px;
      height: 100%;
      border-radius: 1px;
      position: absolute;
      left: -10px;
    }
  }
</style>
